import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import NewPersonCard from 'app/components/People/PeopleContent/PeopleList/NewPersonCard';
import { isDrawerOpenSelector } from 'store/reducers/navbar-reducer';
import { originalPeopleSelector } from 'store/reducers/people/people-reducer';
import { createGlobalStyle } from 'styled-components';

import {
  PeopleStepsOneSpotlightBackgroundCardOne,
  PeopleStepsOneSpotlightBackgroundCardTwo,
  PeopleStepsOneSpotlightWrapper,
} from './styled';

const GlobalStyle = createGlobalStyle`
  [data-id='people-drawer-select'] {
    display: none;
  }
`;

export default function PeopleStepsOneSpotlight() {
  const people = useSelector(originalPeopleSelector);
  const [index, setIndex] = useState<number>(0);
  const [triggerNext, setTriggerNext] = useState<boolean>(false);
  const isDrawerOpen = useSelector(isDrawerOpenSelector);
  const ANIMATION_TIME = 600;

  const nextPerson = () => {
    setTriggerNext(true);
    setTimeout(() => {
      index === people.length - 1 ? setIndex(0) : setIndex(index + 1);
      setTriggerNext(false);
    }, ANIMATION_TIME);
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      const timeout = setTimeout(() => {
        if (people.length === 0) return;
        nextPerson();
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [index, people, isDrawerOpen]);

  if (people.length === 0) {
    return <NewPersonCard.Skeleton />;
  }

  return (
    <>
      <GlobalStyle />
      <PeopleStepsOneSpotlightWrapper>
        <PeopleStepsOneSpotlightBackgroundCardOne triggerNext={triggerNext}>
          <NewPersonCard person={people[index + 1 === people.length ? 0 : index + 1]} />
        </PeopleStepsOneSpotlightBackgroundCardOne>
        <PeopleStepsOneSpotlightBackgroundCardTwo triggerNext={triggerNext}>
          <NewPersonCard person={people[index]} />
        </PeopleStepsOneSpotlightBackgroundCardTwo>
      </PeopleStepsOneSpotlightWrapper>
    </>
  );
}
